import Style from './style'

import PageTitle from 'widget/PageTitle'
import Pagenation from 'widget/Pagenation'

import useGetAccountStoreTicketRecord from 'entity/account/useGetAccountStoreTicketRecord'

import {
	RECEIVE_BY_PRIZE,
	RECEIVE_DIRECT,
	convertRecordTypeAsName,
} from 'shared/constant/lookup/recordType'
import timestampCalculator from 'shared/lib/timestampCalculator'

const MyStoreTicketRecord = () => {
	const [getStoreTicketRecord] = useGetAccountStoreTicketRecord()

	return (
		<Style.Wrapper>
			<PageTitle>내 매장 이용권 사용 기록</PageTitle>

			<Style.RecordList>
				{getStoreTicketRecord?.data?.store_ticket_record?.map((elem) => (
					<Style.RecordElement $increase={parseInt(elem?.change) > 0}>
						<div>
							<h2>{elem?.franchise_name}</h2>
							<p>{elem?.store_name}</p>
							{elem?.event_name && <p>{elem?.event_name}</p>}
							{elem?.ticket_name && <p>{elem?.ticket_name}</p>}
							<Style.RecordDiv
								$inc={[RECEIVE_BY_PRIZE, RECEIVE_DIRECT].includes(
									elem?.ticket_record_type_flag
								)}
							>
								<h2>
									{convertRecordTypeAsName[elem?.ticket_record_type_flag]}
								</h2>
								<p>
									{[RECEIVE_BY_PRIZE, RECEIVE_DIRECT].includes(
										elem?.ticket_record_type_flag
									)
										? '+'
										: '-'}
									{elem?.number}
								</p>
							</Style.RecordDiv>
						</div>
						<p>{timestampCalculator(elem?.created_at, 'date')}</p>
					</Style.RecordElement>
				))}
				{getStoreTicketRecord?.data?.store_ticket_record?.length < 1 && (
					<Style.Option>매장 이용권 사용 기록이 없습니다.</Style.Option>
				)}
			</Style.RecordList>

			<Pagenation maxPage={getStoreTicketRecord?.data?.max_page} />
		</Style.Wrapper>
	)
}

export default MyStoreTicketRecord
